<svg width="38" height="30" viewBox="0 0 38 30" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2229_6274)">
<rect x="12.2" y="2.7" width="13.6" height="24.6" rx="2.8" stroke="currentColor" stroke-width="1.6"/>
<rect x="17" y="6.5" width="4" height="1.4" rx="0.7" fill="currentColor"/>
</g>
<defs>
<clipPath id="clip0_2229_6274">
<rect width="38" height="30" rx="3" fill="white"/>
</clipPath>
</defs>
</svg>
